import React from 'react';
import { useTranslation } from 'react-i18next';

interface VendorDetailsRequestIntroContentProps {
  businessName: string | null;
  billNumber: string | null;
  errorMessage?: string;
}

export const VendorDetailsRequestIntroContent = ({
  billNumber,
  businessName,
  errorMessage,
}: VendorDetailsRequestIntroContentProps) => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col items-center'>
      <div className=' flex flex-col  items-center py-[50px] px-[37px]'>
        <p className='font-metricR text-[18px] text-bw08 '>
          {t('ASK_VENDOR.INTRO.TITLE_1')}
        </p>
        <p className='font-metricRMedium text-[18px] my-[10px] text-bw08 text-center'>
          {errorMessage
            || (businessName && t('ASK_VENDOR.INTRO.TITLE_2', { businessName }))}
        </p>
        {billNumber && (
          <p className='font-metricR text-[14px] text-bw08'>
            {t('ASK_VENDOR.INTRO.TITLE_3', { billNumber })}
          </p>
        )}
      </div>
    </div>
  );
};
